// @ts-nocheck
import React, { useState, useEffect } from "react";
// import LTCheckbox from "../LTCheckbox";
import { LTCheckbox, LTTooltip } from "@lambdatestincprivate/lt-components";
import { CheckboxGroup } from "@primer/react";
import styled from "styled-components";
import PropTypes from "prop-types";
import './checkboxGroup.css'

const CheckboxContainer = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

const CheckBoxGroup: React.FC<any> = ({
  ariaLabelledBy = undefined,
  disabled = false,
  defaultSelected = [],
  id = undefined,
  label = "",
  labelClasses = "",
  options = [],
  disabledOptions = [],
  onChange = () => {},
  visuallyHidden = false,
}) => {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(defaultSelected);

  useEffect(() => {
    if (Array.isArray(defaultSelected)) {
      setSelectedCheckboxes(defaultSelected);
    }
  }, [defaultSelected]);

  function toggleItemInArray(item: any, options: any) {
    const index = options.indexOf(item);
    if (index > -1) {
      return options.filter((_: any, i: any) => i !== index);
    } else {
      return [...options, item];
    }
  }
  const handleCheckboxChange = (lastSelectedValue: any) => {
    let updatedSelected = toggleItemInArray(
      lastSelectedValue,
      selectedCheckboxes
    );
    setSelectedCheckboxes(updatedSelected);
    onChange(updatedSelected);
  };
  const isChecked = (value: any) => {
    return selectedCheckboxes.includes(value);
  };

  return (
    <CheckboxGroup aria-labelledby={ariaLabelledBy} id={id} disabled={disabled}>
      <CheckboxGroup.Label
        visuallyHidden={visuallyHidden}
        className={labelClasses}
      >
        {label}
      </CheckboxGroup.Label>
      <CheckboxContainer>
        {options?.map((checkbox: any, index: any) => {
          const {
            value = index,
            leadingIcon = null,
            trailingIcon = null,
          } = checkbox || {};
          return disabledOptions.includes(checkbox.value) ? (
						<LTTooltip 
							direction={LTTooltip.Direction.RIGHT} 
							text="This service account is already linked to another user in your organization."
							customTriggerStyle={{
								display: "inline-flex",
								flexDirection: "column",
								width: "fit-content"
							}}
							allowContentOverflow={true}
						>
							<li style={{ marginTop: index !== 0 ? "8px" : "" }}>
								<LTCheckbox
									key={value}
									leadingIcon={leadingIcon}
									trailingIcon={trailingIcon}
									shouldHighlightLabel={true}
									checked={isChecked(checkbox.value)}
									disabled={disabledOptions.includes(checkbox.value)}
									onChange={(e) => handleCheckboxChange(checkbox.value, index)}
									{...checkbox}
								/>
							</li>
						</LTTooltip>
          ) : (
						<li style={{ marginTop: index !== 0 ? "8px" : "" }}>
							<LTCheckbox
								key={value}
								leadingIcon={leadingIcon}
								trailingIcon={trailingIcon}
								shouldHighlightLabel={true}
								checked={isChecked(checkbox.value)}
								disabled={disabledOptions.includes(checkbox.value)}
								onChange={(e) => handleCheckboxChange(checkbox.value, index)}
								{...checkbox}
							/>
						</li>
					);
        })}
      </CheckboxContainer>
    </CheckboxGroup>
  );
};

CheckBoxGroup.propTypes = {
  ariaLabelledBy: PropTypes.string,
  disabled: PropTypes.bool,
  defaultSelected: PropTypes.array,
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  leadingIcon: PropTypes.node,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  trailingIcon: PropTypes.node,
  visuallyHidden: PropTypes.bool,
};

export default CheckBoxGroup;
